/** @format */

import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
// import { AiOutlineCloudUpload } from "react-icons/ai";
import "../../styles/dropzone.css";

const DropZone = ({
  onDrop,
  accept,
  multiple,
  maxSize,
  message,
  iconSize,
  link,
}) => {
  const [files, setFiles] = useState([]);

  /**
   * Callback function for handling dropped files.
   *
   * @callback onDropHandler
   * @param {Array<File>} acceptedFiles - Array of accepted files.
   */

  const onDropHandler = useCallback(
    (acceptedFiles) => {
      try {
        if (onDrop) {
          setFiles(acceptedFiles);
          onDrop(acceptedFiles);
        }
      } catch (error) {
        console.log(error);
      }
    },
    [onDrop]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
    accept: accept || {
      "image/jpeg": [],
      "image/png": [],
      "video/mp4": [],
    },
    multiple: multiple || false,
    maxSize: maxSize || 5242880,
  });

  return (
    <div
      {...getRootProps()}
      className={`upload-box ${isDragActive ? "file-upload-active" : ""}`}
    >
      <input {...getInputProps()} />
      <div className="upload-text-wrapper">
        {files.length === 0 && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-cloud-arrow-up-fill"
            viewBox="0 0 16 16"
          >
            <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0z" />
          </svg>
          // <AiOutlineCloudUpload size={`${iconSize || 50}`} />
        )}
        {files.length > 0 && (
          <p className="file-names">
            {files.map((file) => (
              <span key={file?.name}>{`${file?.name}`.slice(0, 30)}</span>
            ))}
          </p>
        )}
      </div>
      {!files.length && !isDragActive && (
        <p className="file-message">
          {message
            ? message
            : "Drag & drop files here, or click to select files"}
          <span className="text-primary"> Browse</span>
        </p>
      )}
      {!files.length && isDragActive && (
        <p className="file-message">Release Here..</p>
      )}
      {isDragActive && <div className="file-overlay"></div>}
    </div>
  );
};

export default DropZone;
